export default __webpack_public_path__ + "static/media/webcatalog.36ce1cfd.jpg";